import React from 'react';
import HeaderFarben from "./components/HeaderFarben";
import FooterFarben from "./components/FooterFarben";
import Allgemein from "./components/Allgemein";
import Themenblock from "./components/Themenblock";
import Kreativmarkt from "./components/Kreativmarkt";
import Methoden from "./components/Methoden";
import Wochenplan from "./components/Wochenplan";

function App() {
    return <>
        <HeaderFarben/>
        <h1 className={'text-5xl text-center'}>Bunter Grundkurs 2026</h1>



        <Wochenplan/>
        <Allgemein/>
        {/*<Kreativmarkt/>*/}
        {/*<Methoden/>*/}
        {/*<Themenblock/>*/}


        <FooterFarben/>
    </>
}

export default App;
